import React, { FC, useMemo } from 'react'
import { GridColDef } from '@mui/x-data-grid-premium'
import { GatewayColumnsDataGrid } from 'src/components/columns/gateway'
import { Gateway, GatewayState } from 'src/api'
import { CommonGatewayList } from './commonGatewaysList'
import { GatewayContextMenu, GatewayMenuItemKey, useGatewayContextMenu, createActionsColumn } from './gatewayContextMenu'

interface AllGatewayListProps {
  isLoading: boolean
  count: number
  data: Gateway[]
  states: GatewayState[]
  refetchGatewayList: () => void
}

export const AllGatewayList: FC<AllGatewayListProps> = ({ data, isLoading, count, states, refetchGatewayList }) => {
  const { currentRow, menuAnchorEl, handleOpenMenu, handleCloseMenu } = useGatewayContextMenu()
  const dataWithState = useMemo(
    () =>
      data.map((row) => ({
        ...row,
        state: states.find((e) => e.id === row.stateId)
      })),
    [data, states]
  )

  const getColumns = (): GridColDef<Gateway>[] => [
    GatewayColumnsDataGrid.DeviceId,
    GatewayColumnsDataGrid.IMEI,
    GatewayColumnsDataGrid.DevEUI,
    GatewayColumnsDataGrid.ExternalDeviceId,
    GatewayColumnsDataGrid.OnlineStatus,
    GatewayColumnsDataGrid.LastPingAt,
    GatewayColumnsDataGrid.Name,
    GatewayColumnsDataGrid.State,
    GatewayColumnsDataGrid.Contractor,
    GatewayColumnsDataGrid.Project,
    GatewayColumnsDataGrid.CreatedAt,
    createActionsColumn(handleOpenMenu)
  ]

  return (
    <>
      <CommonGatewayList columns={getColumns()} count={count} data={dataWithState} isLoading={isLoading} />
      <GatewayContextMenu
        menuItems={[GatewayMenuItemKey.MarkAsLost, GatewayMenuItemKey.MakeAvailable]}
        currentRow={currentRow}
        menuAnchorEl={menuAnchorEl}
        onOpenMenu={handleOpenMenu}
        onCloseMenu={handleCloseMenu}
        states={states}
        refetchGatewayList={refetchGatewayList}
      />
    </>
  )
}
